import React from 'react';
import CollapseWrapper from '@hpstellar/core/CollapseWrapper/CollapseWrapper.js'

import Reviews from '../../../bv/components/bv-reviews'
//TODO: This probably needs to be moved in the product detail section
import BvScript from '../../../bv/components/bv-script'
import withPageComponents from '../../../page/components/with-page-components';

import './review.less'


const pdpGallery = ({ product }) => {
    return product ?
        <CollapseWrapper
            title='Reviews'
            desktopTitle='Reviews'
            className='pdp-reviews'
        >
            <BvScript sku={product.sku} />
            <Reviews product={product} />
        </CollapseWrapper> : null;
}

export default withPageComponents(pdpGallery, { components: ['product'] })
